import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

export default function PharmacyTooltip(prop: any) {
  const { row } = prop;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Pharmacy Id:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyId)
            ? "Not Available"
            : row.pharmacyId}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Pharmacy Name:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyName)
            ? "Not Available"
            : row.pharmacyName}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Pharmacy Address:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyAddress)
            ? "Not Available"
            : row.pharmacyAddress}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Phone:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyPhone)
            ? "Not Available"
            : row.pharmacyPhone}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Fax:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyFaxNumber)
            ? "Not Available"
            : row.pharmacyFaxNumber}{" "}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          LandMark:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.landMark) ? "Not Available" : row.landMark}{" "}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          City:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.city) ? "Not Available" : row.city}{" "}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          State:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.state) ? "Not Available" : row.state}{" "}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Zip:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.zip) ? "Not Available" : row.zip}{" "}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          24 Hours Service:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.twentyFourHourFlag)
            ? "Not Available"
            : row.twentyFourHourFlag}{" "}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Store:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.storeNumber)
            ? "Not Available"
            : row.storeNumber}{" "}
        </Typography>
      </Grid>
    </Grid>
  );
}
